import { FC } from 'react';

export interface HeadlineFromCraftProps {
  primarySansSerif: string;
  secondarySerif?: string;
  lineBreak?: boolean;
}

const formHeadline = (headlineElements: HeadlineFromCraftProps): React.ReactNode => {
  if ((headlineElements.secondarySerif) && (headlineElements.lineBreak)) {
    return <span>{headlineElements.primarySansSerif} <br/><span className="font-serif">{headlineElements.secondarySerif}</span></span>
  }

  if ((headlineElements.secondarySerif)) {
    return <span>{headlineElements.primarySansSerif} <span className="font-serif">{headlineElements.secondarySerif}</span></span>
  }

  return <span>{headlineElements.primarySansSerif}</span>;
};


const SerifAndSansSerifHeadline: FC<HeadlineFromCraftProps> = (props: HeadlineFromCraftProps) => {
  return formHeadline(props);
};

export default SerifAndSansSerifHeadline;
